
import { Col, Container, Row } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useEffect, useState, useRef } from 'react';
import Bannerimg from '../assets/images/gallery/gallery-2.jpg';
import InputGroup from 'react-bootstrap/InputGroup';

// New package blog-card
import { BlogCard } from '@veeyaainnovatives/blog-card';
import useCustom from "../hooks/useCustom";
import placeholderImage from '../assets/images/placholder.png';

import Form from 'react-bootstrap/Form';

const Blogs = () => {

  const {
    fetchBlogs,
    loading,
    blogs
  } = useCustom();

  const blogImg = "https://www.housegyan.com/_next/image?url=https%3A%2F%2Fimages.housegyan.com%2Fmedia%2F1729055436508-Villa_Styled_Double_Floor_House_Front_Elevation_Designs.webp&w=1080&q=50"

  const [searchTerm, setSearchTerm] = useState("");
  const debounceTimer = useRef(null);

  // Initial load
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounced search function
  useEffect(() => {
    // Clear previous timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set new timer for debounced search
    debounceTimer.current = setTimeout(() => {
      fetchBlogs(searchTerm);
    }, 500); // 500ms delay

    // Cleanup function
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return (
    <>

      <div style={{ backgroundImage: `url(${Bannerimg}` }} alt="banner-img" className="banner-img" >
        <div className="overlay p-md-5">
          <Container>
            <Row className="justify-content-md-center">
              <Col xs lg="6">
                <h1 className='banner-title'>Our <span className="theme-color-green">Blogs</span></h1>

                <Form
                  onSubmit={(e) => {
                    e.preventDefault(); // prevent page refresh
                    // Search is handled by onChange with debounce
                  }}
                >
                  <InputGroup className="my-4 position-relative">

                    <Form.Control
                      placeholder="Search for Blogs ..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {/* Clear Icon */}
                    {searchTerm.length > 0 && (
                      <span
                        className="clear-btn"
                        onClick={() => {
                          setSearchTerm("");
                          // Clear debounce timer and fetch immediately
                          if (debounceTimer.current) {
                            clearTimeout(debounceTimer.current);
                          }
                          fetchBlogs("");
                        }}
                      >
                        &times;
                      </span>
                    )}

                    <Button 
                      type="button" 
                      onClick={() => fetchBlogs(searchTerm)}
                      className="btn-search"
                      backgroundColor="#677a58"
                      color="#ffffff"
                      hoverBackgroundColor="#5a6a4a"
                      width="75px"
                      height="57px"
                      borderRadius="0px 100px 100px 0px"
                      padding="0"
                      icon="fa-solid fa-magnifying-glass"
                    />
                  </InputGroup>
                </Form>


              </Col>
            </Row>
          </Container>

        </div>
      </div>

      <div className="body-wrap overflow-hidden mt-5">

        {loading && (
          <section className="loading-screen height-25-p">
            <div className="loader-wrapper">
              <div className="spinner"></div>
              <h4 className="loading-text">Loading ...</h4>
            </div>
          </section>
        )}

        {!loading && (
          <section className='py-4'>
            <Container >
              {blogs && blogs.length > 0 ? (
                <BlogCard blogs={blogs} placeholderImage={placeholderImage} />
              ) : (
                <div className="text-center py-5">
                  <div className="mb-4">
                    <i className="fa-solid fa-file-lines" style={{ fontSize: '64px', color: '#ccc' }}></i>
                  </div>
                  <h3 className="mb-3">No Blogs Available</h3>
                  {searchTerm ? (
                    <p className="text-muted">
                      No blogs found for "<strong>{searchTerm}</strong>". Please try a different search term.
                    </p>
                  ) : (
                    <p className="text-muted">
                      There are no blogs available at the moment. Please check back later.
                    </p>
                  )}
                </div>
              )}
            </Container>
          </section>
        )}

      </div>
    </>
  );
}

export default Blogs;